import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import { IGenericBusinessPartnersPlansTableData } from '.';
import FormattingService from '@services/FormattingService';

export function mapToBusinessPartnersPlansListingData(
  data: any
): IListingData<any> {
  const list: IAbstractRecord = {};

  data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.items?.forEach(
    (obj: IGenericBusinessPartnersPlansTableData, i: number) => {
      list[i] = {
        salesforceManagement_AssignedBPPlan_Id:
          obj.salesforceManagement_AssignedBPPlan_Id,
        businessPartner_Code:
          obj.salesforceManagement_AssignedBPPlan_BusinessPartnerID?.views
            ?.SalesforceManagement_all?.properties?.Code,

        businessPartner_PersonID_ID:
          obj.salesforceManagement_AssignedBPPlan_BusinessPartnerID?.id,
        person_FullName:
          obj.businessPartner_PersonID?.views?.SalesforceManagement_all
            ?.properties?.FullName,

        salesforceManagement_AssignedBPPlan_LineID_ID:
          obj.salesforceManagement_AssignedBPPlan_LineID?.id,
        line_ExternalCode:
          obj.salesforceManagement_AssignedBPPlan_LineID?.views
            ?.PlanConfigManagement_all?.properties?.ExternalCode,
        line_Name:
          obj.salesforceManagement_AssignedBPPlan_LineID?.views
            ?.PlanConfigManagement_all?.properties?.Name,

        salesforceManagement_AssignedBPPlan_PlanID_ID:
          obj.salesforceManagement_AssignedBPPlan_PlanID?.id,
        plan_ExternalCode:
          obj.salesforceManagement_AssignedBPPlan_PlanID?.views
            ?.PlanConfigManagement_all?.properties?.ExternalCode,
        plan_Name:
          obj.salesforceManagement_AssignedBPPlan_PlanID?.views
            ?.PlanConfigManagement_all?.properties?.Name,

        salesforceManagement_AssignedBPPlan_BusinessPartnerLineID_Status:
          obj.salesforceManagement_AssignedBPPlan_BusinessPartnerLineID?.views
            ?.SalesforceManagement_all?.properties?.Status,
        salesforceManagement_AssignedBPPlan_BusinessPartnerPlanID_Status:
          obj.salesforceManagement_AssignedBPPlan_BusinessPartnerPlanID?.views
            ?.SalesforceManagement_all?.properties?.Status,

        salesforceManagement_AssignedBPPlan_Status:
          FormattingService.formatEnumToDisplay(
            obj.salesforceManagement_AssignedBPPlan_Status
          ),
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageSize,
    pageNumber:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageNumber,
    totalCount:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.totalCount,
  };
}

export function extractAssignedBP(
  data: any,
  planData: any
): Record<string, Record<string, string>> {
  const lovs: Record<string, Record<string, string>> = {
    bp: {},
    line: {},
    plan: {},
  };
  data?.SalesforceManagement?.queries?.getAssignedBPListWithoutPagination.forEach(
    (element: {
      salesforceManagement_AssignedBP_BusinessPartnerID: {
        id: string;
        views: {
          SalesforceManagement_all: {
            properties: {
              PersonID: {
                views: {
                  SalesforceManagement_all: {
                    properties: {
                      FullName: string;
                    };
                  };
                };
              };
            };
          };
        };
      };
    }) => {
      lovs.bp[element.salesforceManagement_AssignedBP_BusinessPartnerID?.id] =
        element.salesforceManagement_AssignedBP_BusinessPartnerID?.views?.SalesforceManagement_all?.properties?.PersonID?.views?.SalesforceManagement_all?.properties?.FullName;
    }
  );

  data?.SalesforceManagement?.queries?.getDistinctAssignedBPLineListWithoutPagination?.forEach(
    (obj: {
      salesforceManagement_AssignedBPPlan_LineID: {
        id: string;
        views: {
          PlanConfigManagement_all: {
            properties: {
              Name: string;
              ExternalCode: string;
            };
          };
        };
      };
    }) => {
      lovs.line[obj?.salesforceManagement_AssignedBPPlan_LineID?.id] =
        `${obj?.salesforceManagement_AssignedBPPlan_LineID?.views?.PlanConfigManagement_all?.properties?.Name}`;
    }
  );

  planData?.SalesforceManagement?.queries?.getDistinctAssignedBPPlanListWithoutPagination?.forEach(
    (obj: {
      salesforceManagement_AssignedBPPlan_PlanID: {
        id: string;
        views: {
          PlanConfigManagement_all: {
            properties: {
              Name: string;
              ExternalCode: string;
            };
          };
        };
      };
    }) => {
      lovs.plan[obj?.salesforceManagement_AssignedBPPlan_PlanID?.id] =
        `${obj?.salesforceManagement_AssignedBPPlan_PlanID?.views?.PlanConfigManagement_all?.properties?.Name}`;
    }
  );

  return lovs;
}

export function extractDistinctLines(data: any): IListingData<any> {
  const list: IAbstractRecord = {};

  data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.items?.forEach(
    (obj: IGenericBusinessPartnersPlansTableData, i: number) => {
      list[i] = {
        salesforceManagement_AssignedBPPlan_LineID_ID:
          obj.salesforceManagement_AssignedBPPlan_LineID?.id,
        salesforceManagement_AssignedBPPlan_LineID_Name:
          obj.salesforceManagement_AssignedBPPlan_LineID?.views
            ?.PlanConfigManagement_all?.properties?.Name,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageSize,
    pageNumber:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageNumber,
    totalCount:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.totalCount,
  };
}

export function extractDistinctPlans(data: any): IListingData<any> {
  const list: IAbstractRecord = {};

  data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.items?.forEach(
    (obj: IGenericBusinessPartnersPlansTableData, i: number) => {
      list[i] = {
        salesforceManagement_AssignedBPPlan_PlanID_ID:
          obj.salesforceManagement_AssignedBPPlan_PlanID?.id,
        salesforceManagement_AssignedBPPlan_PlanID_Name:
          obj.salesforceManagement_AssignedBPPlan_PlanID?.views
            ?.PlanConfigManagement_all?.properties?.Name,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageSize,
    pageNumber:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.pageNumber,
    totalCount:
      data?.SalesforceManagement?.queries?.getAssignedBPPlanList?.paging
        ?.totalCount,
  };
}
